const styles = () => ({
  sectionAction: {
    marginLeft: 'auto',
  },

  field: {
    marginTop: 8,
    width: '50%',
  },

  fieldAdornment: {
    margin: '0 0 0 8px',
  },

  requiredLabel: {
    fontSize: 12,
    opacity: 0.5,
    marginTop: 8,
  },

  hint: {
    fontSize: 14,
    marginBottom: 0,
    background: '#f9f9f9',
  },

  radioRoot: {
    padding: 0,
    marginRight: 8,
  },

  segmentToggleGroup: {
    '&&': {
      width: '100%',
      padding: 0,
      overflow: 'visible',
      margin: 0,
      marginBottom: 24,
    },
  },

  segmentToggle: {
    width: '50%',
    textAlign: 'left',
    paddingBottom: 16,
    paddingTop: 12,
    flexGrow: '1',
    justifyContent: 'left',

    '&:first-child': {
      marginLeft: 0,
    },

    '&:last-child': {
      marginRight: 0,
    },

    '& p': {
      '&:first-child': {
        color: 'rgb(39, 40, 42)',
        fontSize: 15,
        fontWeight: 500,
        lineHeight: '30px',
        paddingBottom: 8,

        '& > svg': {
          display: 'inline-flex',
          verticalAlign: 'middle',
          marginRight: 8,
        },
      },

      '&:last-child': {
        color: 'rgb(89, 97, 104)',
        fontSize: 14,
        lineHeight: '20px',
      },
    },
  },

  sectionTile: {
    width: 32,
    height: 32,
  },

  pill: {
    background: 'rgb(242, 250, 254)',
    borderRadius: 16,
    border: '1px solid rgb(219, 241, 254)',
    margin: '-8px 8px',
    padding: '2px 16px',
    color: 'rgb(39, 40, 42)',
    fontSize: 15,
    display: 'inline-flex',
    alignItems: 'center',
    position: 'relative',
    top: 2,

    '& svg': {
      marginRight: 8,
    },
  },

  previewButton: {
    marginLeft: 'auto',
  },
});

export default styles;
